// project import
import { useEffect, useState } from "react";
import Navigation from "./Navigation";
import SimpleBar from "components/third-party/SimpleBar";
import menuItem from "menu-items/admin";
import { Box, Divider, List } from "@mui/material";
import NavItem from "./Navigation/NavItem";
import { useNotifications } from "contexts/NotificationContext";

// Import notification icon
import notificationIcon from "../../../../assets/icons/notification-03.svg";

// Format notification count to short version (e.g. 1.2k)
const formatCount = (count) => {
  if (count >= 1000) {
    return (count / 1000).toFixed(1).replace(/\.0$/, "") + "k";
  }
  return count.toString();
};

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  const [menuItems, setMenuItems] = useState({ items: [] });
  const { adminUnreadCount, adminReportCount, adminCommentCount } =
    useNotifications();

  useEffect(() => {
    // Create a deep clone of the menu items
    const updatedMenuItems = JSON.parse(JSON.stringify(menuItem));

    // Find and update the notifications item with the dynamic badge count
    const notificationsItem = updatedMenuItems.items.find(
      (item) => item.id === "notifications",
    );

    if (notificationsItem) {
      // Ensure icon is properly set
      notificationsItem.icon = () => (
        <img src={notificationIcon} alt="notification icon" />
      );

      // Add the badge count if there are unread notifications
      if (adminUnreadCount > 0) {
        notificationsItem.chip = {
          label: formatCount(adminUnreadCount),
          color: "error",
          size: "small",
        };
      }
    }

    setMenuItems(updatedMenuItems);
  }, [adminUnreadCount, adminReportCount, adminCommentCount]);

  // Find the notifications menu item
  const notifications = menuItems.items.find(
    (item) => item.id === "notifications",
  );

  return (
    <>
      <SimpleBar
        sx={{
          "& .simplebar-content": { display: "flex", flexDirection: "column" },
        }}
      >
        <Navigation />
      </SimpleBar>

      <Box sx={{ mt: "auto", mb: 2 }}>
        {notifications && (
          <>
            <Divider
              sx={{
                my: "10px !important",
                width: "80%",
                margin: "auto",
                opacity: ".5",
              }}
            />
            <List sx={{ py: "3px" }}>
              <NavItem item={notifications} level={1} isParents />
            </List>
          </>
        )}
      </Box>
    </>
  );
}
